// extracted by mini-css-extract-plugin
export var borderRadius = "_9o-4";
export var large = "_9o-3";
export var logoContainer = "_9o-0";
export var nameLogo = "_9o-2";
export var small = "_9o-1";